import { useEffect, useState } from "react";
import { container } from "tsyringe";
import DefaultAvatar from "assets/images/default-avatar.svg";
import UserPublicResponseResource from "common/resources/User/UserPublicResponseResource";
import UserService from "services/UserService";

const userService = container.resolve(UserService);

export const useAvatar = (user: Pick<UserPublicResponseResource, "id">) => {
	const [avatar, setAvatar] = useState<string>(DefaultAvatar);

	useEffect(() => {
		userService.getProfilePictureUrl(user.id).then((url) => setAvatar(url ?? DefaultAvatar));
	}, [user.id]);

	return { avatar };
};
